// Third-Party Libraries
import styled from "styled-components";

export const DivMain = styled.div`
  width: 100%;
  height: 100%;
`;

export const DivRtl = styled.div`
  direction: rtl;
`;

export const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DivRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const WidgetMarginHeight = styled.div`
  height: ${(props) => props.height || "0rem"};
`;

export const WidgetMarginWidth = styled.div`
  width: ${(props) => props.width || "0rem"};
`;

export const ParagraphText = styled.p`
  direction: rtl;
  margin: 0;
`;

export const Input = styled.input.attrs({ type: "text" })`
  display: flex;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
  font-family: Montserrat;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.6rem;
  color: #2b308b;
  direction: rtl;
  background: transparent;
  ${(props) => props.disabled && "opacity: 0.5;"}
`;

export const InputTwo = styled(Input)`
  color: #3e417a;
  font-family: Heebo;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4rem;
`;

export const AlertDialogBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(0.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
`;
